import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { IntlProvider } from 'react-intl';
import { KeycloakProvider } from './context/KeycloakContext';
import { ConsentProvider, useConsent } from './context/ConsentContext';
import Config from './config/Config';
import Navigation from './navigation/Navigation';
import ProfilePage from './pages/ProfilePage';
import SearchPage from './pages/SearchPage';
import SearchResultPage from './pages/SearchResultPage';
import NotFoundPage from './pages/NotFoundPage';
import NotAuthorizedPage from './pages/NotAuthorizedPage';
import AccessControlPage from './pages/AccessControlPage';
import CookieConsentBanner from './components/CookieConsentBanner';

// Stylesheets
import 'bootstrap/dist/css/bootstrap.min.css';

// Translations
import messagesEn from './locales/en.json';
import messagesDe from './locales/de.json';

function AppInner() {
  const defaultLanguage = Config.defaultLanguage;
  const { consent } = useConsent();

  const storedLocale = localStorage.getItem('locale');
  const initialLocale = storedLocale ? storedLocale : defaultLanguage;

  const [locale, setLocale] = useState(initialLocale);

  useEffect(() => {
    document.title = Config.appName;
  }, []);

  useEffect(() => {
    if (consent === 'accepted') {
      localStorage.setItem('locale', locale);
    } else if (consent === 'declined') {
      localStorage.removeItem('locale');
    }
  }, [locale, consent]);

  const toggleLanguage = (language) => {
    setLocale(language);
  };

  function PrivateRoute() {
    return <Outlet />;
  }

  function PublicRoute() {
    return <Outlet />;
  }

  return (
    <IntlProvider locale={locale} messages={locale === 'de' ? messagesDe : messagesEn}>
      <Router>
        <Navigation toggleLanguage={toggleLanguage} currentLanguage={locale} />
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<SearchPage />} />
            <Route path="/search" element={<SearchResultPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/access-control" element={<AccessControlPage />} />
          </Route>
          <Route element={<PublicRoute />}>
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/not-authorized" element={<NotAuthorizedPage />} />
          </Route>
        </Routes>
        <CookieConsentBanner />
      </Router>
    </IntlProvider>
  );
}

function App() {
  return (
    <ConsentProvider>
      <KeycloakProvider>
        <AppInner />
      </KeycloakProvider>
    </ConsentProvider>
  );
}

export default App;